export default __webpack_public_path__ + "static/media/spaceShipG4.849f86fe.webp";